import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import DescriptionField from "../../../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../../../components/common/theme-button/ThemeButton";
import {checkEmptySpaces, maxLength, Required} from "../../../../../utils/patterns";
import {CloseRoundedCheck, RoundedCheck} from "../../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import EditGratitudeSkeleton from "../../../../skeletons/gratitude/EditGratitudeSkeleton";
import {PillarsService} from "../../../../../services/pillars-api.service";

export default function EditArchive({close, getListing, setGetListing, id}) {
    const[loader,setLoader] = useState(true);
    const[question,setQuestion] = useState(false);
    const [singleGratitudeData, setSingleGratitudeData] = useState(false)
    const [singlePillarData, setSinglePillarData] = useState(false)

    async function GetSinglePillarData(id) {
        setLoader(true)
        const response = await PillarsService.getSinglePillar(id);

        if(response?.data?.data?.status){
            setSinglePillarData(response.data?.data?.data?.result)
            const payload = {
                des: response?.data?.data?.data?.result.content[0].text
            };
            reset(payload);
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetSinglePillarData(id)

    },[id])

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors, isValid},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                content: [
                    {
                        label: singlePillarData.content[0].label,
                        text: data.des
                    }
                ]
            }
            const response = await PillarsService.updateCurrentDatePillars(id,payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: response.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setGetListing(!getListing)
                setLoader(false)
            }
            else{
                notification.error({
                    message: "Failed",
                    description: response.data?.data?.message,
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }

    if(loader){
        return <EditGratitudeSkeleton/>
    }

    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={''}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(500) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your text here'}
                                type={'text'}
                                label={singlePillarData.content[0].label}
                                field={field}
                                errors={errors.des}
                                autoSize={{ minRows: 12, maxRows: 12 }}
                                defaultValue={''}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Submit'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}